import tr from './tr.json';
import en from './en.json';
import { locales as uiLocales } from '@akademi/ui/locales';

/** i18next namespace this package owns. */
export const NS = 'site-builder-runtime';

/**
 * Base translation catalogue for the `site-builder-runtime` namespace.
 *
 * <p>This is the shipped floor. Tenant overrides fetched from the i18ln backend
 * are layered over it at runtime by `TenantI18nOverridesSync`, so editing a
 * label here changes the default for every institution that has not overridden
 * it — and changes nothing for one that has.
 * <p>Also re-exports `@akademi/ui` so the host app
 * reaches namespaces owned by dependencies it cannot import directly under
 * pnpm's strict layout.
 */
export const locales = [...uiLocales, { ns: NS, resources: { tr, en } }];
